import { GlButton, GlModal } from '@gitlab/ui';
import { s__, sprintf } from '~/locale';
import { lowercaseWorkItemType } from '../utils';
export default {
    name: 'CreateWorkItemCancelConfirmationModal',
    components: {
        GlButton,
        GlModal
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        workItemType: {
            type: String,
            required: true
        }
    },
    emits: [
        'continue-editing',
        'discard-draft'
    ],
    computed: {
        cancelConfirmationText () {
            return sprintf(s__('WorkItem|Are you sure you want to cancel creating this %{workItemType}?'), {
                workItemType: lowercaseWorkItemType(this.workItemType)
            });
        }
    },
    methods: {
        handleCancelConfirmationAction (decision) {
            if (decision === 'continueEditing') {
                this.$emit('continue-editing');
            } else {
                this.$emit('discard-draft');
            }
        }
    }
};
